import React from 'react'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import { withRouter } from 'react-router'

import ContentAdd from 'material-ui/svg-icons/content/add'
import ArrowUpward from 'material-ui/svg-icons/navigation/arrow-upward'
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import FlatButton from 'material-ui/FlatButton'
import {
  Card,
  CardActions,
  CardHeader,
  CardText,
  CardTitle
} from 'material-ui/Card'

import api from '../../api'
import Edit from './edit'
import Create from './create'

const styles = {
  form: {
    maxWidth: 500
  },
  cardActions: {
    marginTop: '15px',
    float: 'right'
  },
  cardTitle: {
    paddingLeft: 0
  },
  paperInner: {
    padding: '15px'
  }
}

const sortByPosition = (a, b) => {
  if (a.position < b.position) {
    return -1
  } else if (a.position > b.position) {
    return 1
  } else {
    return 0
  }
}

class List extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      blockTypes: [],
      pageBlocks: [],
      addNew: false,
      dirty: false
    }
  }

  componentWillMount () {
    this.fetchBlockTypes()
    this.fetchPageBlocks()
    this.props.router.setRouteLeaveHook(
      this.props.route,
      this.routerWillLeave.bind(this)
    )
  }

  render () {
    const { blockTypes, addNew } = this.state

    const getBlockType = (block) =>
      find(blockTypes, { type: block.block_type })

    const pageBlocks = this.state.pageBlocks.sort(sortByPosition)

    return (
      <div>
        <CardTitle title={this.props.title || 'Blocks'} />
        {pageBlocks.map((pageBlock) => {
          const blockType = getBlockType(pageBlock)
          if (!blockType) {
            return <div key={pageBlock.id} />
          }

          return (
            <Card key={pageBlock.id}>
              <CardHeader
                title={pageBlock.block_type}
                actAsExpander
                showExpandableButton
              />
              <CardActions>
                <FlatButton
                  icon={<ArrowUpward />}
                  onClick={this.handleBlockPositionChanged.bind(
                    this,
                    pageBlock,
                    'up'
                  )}
                />
                <FlatButton
                  icon={<ArrowDownward />}
                  onClick={this.handleBlockPositionChanged.bind(
                    this,
                    pageBlock,
                    'down'
                  )}
                />
              </CardActions>
              <CardText expandable>
                <Edit
                  key={1}
                  target={this.props.target}
                  blockType={blockType}
                  pageBlock={pageBlock}
                  onBlockUpdated={this.handleBlockUpdated.bind(this)}
                  onBlockDeleted={this.handleBlockDeleted.bind(this)}
                  onDirty={this.setDirty.bind(this)}
                />
              </CardText>
            </Card>
          )
        })}

        {!addNew && (
          <div>
            <CardActions style={styles.cardActions}>
              <FloatingActionButton onClick={this.handleAddNew.bind(this)}>
                <ContentAdd />
              </FloatingActionButton>
            </CardActions>
          </div>
        )}

        {addNew && (
          <Card>
            <CardHeader title='Add Block' />
            <CardText>
              <Create
                target={this.props.target}
                cmsPageProp={this.props.cmsPageProp}
                cmsPageId={this.props.cmsPageId}
                blockTypes={blockTypes}
                onBlockCreated={this.handleBlockCreated.bind(this)}
                onCancel={this.handleCancelCreate.bind(this)}
                onDirty={this.setDirty.bind(this)}
              />
            </CardText>
          </Card>
        )}
      </div>
    )
  }

  handleAddNew () {
    this.setState({ addNew: true })
  }

  handleBlockCreated (block) {
    this.setState((prevState) => {
      return {
        ...prevState,
        addNew: false,
        pageBlocks: prevState.pageBlocks.concat(block)
      }
    })
  }

  handleBlockUpdated (block) {
    this.setState((prevState) => {
      const index = findIndex(prevState.pageBlocks, { id: block.id })
      prevState.pageBlocks[index] = block
      return prevState
    })
  }

  handleBlockDeleted (block) {
    this.setState((prevState) => {
      const index = findIndex(prevState.pageBlocks, { id: block.id })
      prevState.pageBlocks.splice(index, 1)
      return prevState
    })
  }

  handleCancelCreate () {
    this.setState({ addNew: false })
  }

  handleBlockPositionChanged (block, direction) {
    const { pageBlocks } = this.state
    const currentIndex = findIndex(pageBlocks, { id: block.id })

    if (direction === 'up' && currentIndex > 0) {
      pageBlocks.splice(
        currentIndex - 1,
        0,
        pageBlocks.splice(currentIndex, 1)[0]
      )
    } else if (direction === 'down' && currentIndex !== pageBlocks.length - 1) {
      pageBlocks.splice(
        currentIndex + 1,
        0,
        pageBlocks.splice(currentIndex, 1)[0]
      )
    }

    const repositionBlocks = pageBlocks.map((pageBlock, index) => {
      const body = {
        position: index + 1
      }
      return api
        .patch(`admin/${this.props.target}/${pageBlock.id}`, { body })
        .then((res) => res.json())
    })

    Promise.all(repositionBlocks).then((pageBlocks) => {
      this.setState({ pageBlocks })
    })
  }

  fetchBlockTypes () {
    return api
      .get('admin/cms_block_types')
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          blockTypes: data.filter((block) => {
            if (block.category === 'header') {
              return false
            }

            if (block.fixedPage) {
              const supportsFixedPageBlock =
                this.props.target === 'cms_fixed_page_blocks' &&
                this.props.cmsPageProp === 'page' &&
                this.props.cmsPageId === block.fixedPage

              if (!supportsFixedPageBlock) {
                return false
              }
            }

            if (this.props.allowedBlockTypes && !this.props.allowedBlockTypes.includes(block.type)) {
              return false
            }

            return true
          })
        })
      })
  }

  fetchPageBlocks () {
    const body = {
      [`filters[${this.props.cmsPageProp}]`]: this.props.cmsPageId
    }
    return api
      .get(`admin/${this.props.target}`, { body })
      .then((res) => res.json())
      .then((data) => {
        this.setState({ pageBlocks: data })
      })
  }

  setDirty () {
    if (!this.state.dirty) {
      this.setState({ dirty: true })
    }
  }

  routerWillLeave (nextLocation) {
    if (this.state.dirty) {
      return 'Your work is not saved! Are you sure you want to leave?'
    }
  }
}

// @ts-ignore
List.propTypes = {
  target: React.PropTypes.string.isRequired,
  cmsPageId: React.PropTypes.string.isRequired,
  cmsPageProp: React.PropTypes.string.isRequired,
  title: React.PropTypes.string,
  route: React.PropTypes.object.isRequired,
  allowedBlockTypes: React.PropTypes.arrayOf(React.PropTypes.string)
}

export default withRouter(List)
